
import { defineComponent } from "@vue/runtime-core"

export default defineComponent({
    props: {
        ariaValueText: { type: String, default: 'הדף נטען' }
    }
});
